<template>
<div class="OrderManagement">
      <div class="fansmgt-seach" >
                <template>
                    <!-- <el-select v-model="searchData.tagValue" placeholder="全部来源" class="marginright" style="width:116px">
                        <el-option
                            v-for="item in searchData.tag"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select> -->
                    <span style="margin-right:20px">关联时间</span>
                    <el-date-picker class="item" v-model="searchData.time.date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                    <el-input v-model="searchData.selectValue" placeholder="输入姓名/手机号" class="marginright" style="width:240px"></el-input>
                    <el-button type="primary" plain style="width:96px" class="marginright" @click="search()">搜索</el-button>
                </template>

                <!-- <template>
                    <el-button type="primary" class="post-message" icon="el-icon-message" @click="postMessage()" plain>群发短信</el-button>
                </template> -->
            </div>

            <el-table :data="tableData" class="fansmgt-table">
                <!-- <el-table-column type="selection" width="55px"></el-table-column> -->
                <el-table-column label="头像/姓名" align="left" width="200">
                    <template slot-scope="scope">
                        <div class="fansmgt-name">
                            <template v-if="scope.row.logourl">
                                <img :src="scope.row.logourl" alt="img">
                            </template>
                            <template v-else>
                                <img  src="@/common/images/fansmgt/icon_headerimg.png" alt="img">
                            </template>

                            <p>{{scope.row.name}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column  label="手机号码" align="center" width="100">
                    <template slot-scope="scope">
                        <template v-if="scope.row.mobileno !== ''">{{scope.row.mobileno}}</template>
                        <template v-else>-</template>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="关联时间" align="center" width="200"></el-table-column>
                <el-table-column prop="ordercount" label="下单数" align="center"></el-table-column>
                <el-table-column prop="succordercount" label="成交单数" align="center"></el-table-column>
                <el-table-column prop="succordermoney" label="成交金额" align="center"></el-table-column>
                <el-table-column prop="lastordertime" label="最后交易时间" align="center" width="200"></el-table-column>
                <!-- <el-table-column prop="fansource" label="来源" align="center"></el-table-column> -->
                <el-table-column prop="memo" label="备注" align="center"></el-table-column>
                <el-table-column label="操作" align="right">

                    <template slot-scope="scope">
                        <div class="fansmgt-position">
                            <!-- <el-button type="text" size="small" @click="clickMemo(scope.row.innerid)">备注</el-button>
                            <i class="separator">|</i> -->
                            <el-button type="text" size="small" @click="clickFansDetails(scope.row.innerid)">详情</el-button>
                            <!-- <i class="separator">|</i>
                            <el-button v-if="scope.row.mobileno !== ''" type="text" size="small" @click="postMessage(scope.row.innerid)">发送短信</el-button> -->
                        </div>
                    </template>


                </el-table-column>
            </el-table>

            <el-pagination
                background
                layout="prev, pager, next"
                :total="rowCount" align="center" @current-change="fPage()" :current-page.sync="currentPage">
            </el-pagination>


            <el-dialog title="粉丝详细信息" :visible.sync="fansDialogVisible">
                <div class="fans-details">
                    <el-row>
                        <el-col :span="24">

                            <template v-if="fansDetailsMsg.logourl">
                                <img class="headerimg" :src="fansDetailsMsg.logourl" alt="img">
                            </template>
                            <template v-else>
                                <img class="headerimg" src="@/common/images/fansmgt/icon_headerimg.png" alt="img">
                            </template>

                            <div>
                                <p>{{fansDetailsMsg.name}}</p>
                                <p class="city">
                                    <img v-if="fansDetailsMsg.sex == '女'" class="sex" src="@/common/images/fansmgt/icon_female.jpg" alt="female">
                                    <img v-else class="sex" src="@/common/images/fansmgt/icon_male.jpg" alt="male">
                                </p>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row class="other-content">
                        <el-col class="fans-item" :span="10">
                            <span>姓名</span> : <span>{{ fansDetailsMsg.name }}</span>
                        </el-col>
                        <el-col class="fans-item" :span="10">
                            <span>生日</span> : <span>{{ fansDetailsMsg.birth }}</span>
                        </el-col>
                        <el-col class="fans-item" :span="10">
                            <span>手机号码</span> : <span>{{ fansDetailsMsg.mobileno }}</span>
                        </el-col>
                        <el-col class="fans-item" :span="10">
                            <span>邮箱</span> : <span>{{ fansDetailsMsg.email }}</span>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col class="fans-item" :span="24"><span>来源</span> : <span>{{fansDetailsMsg.fansource}}</span></el-col>
                        <el-col class="fans-item" :span="24"><span>创建时间</span> : <span>{{fansDetailsMsg.datetime}}</span></el-col>
                    </el-row>
                </div>
            </el-dialog>


            <!-- <el-dialog
                title="增加备注"
                :visible.sync="memoDialogVisibale"
                :before-close="clearMemo"
                width="30%">

                <el-input
                    type="text"
                    placeholder="请输入内容"
                    v-model="memo.value"
                    maxlength="10"
                    show-word-limit />

                <span slot="footer" class="dialog-footer">
                    <el-button @click="memoDialogVisibale = false">取消</el-button>
                    <el-button type="primary" @click="memoSubmit">增加</el-button>
                </span>
            </el-dialog> -->
</div>
</template>

<script>
import {getFansInfo,saveFansMemo, findOrderFansList} from '@/api/fansApi' // 引入粉丝管理 api 资源文件
import {getCookie} from '@/common/js/tools'    // 引入 tools 库
import Loading from 'base/loading/loading'    // 引入 loading 组件
import {mapActions} from 'vuex'       // 引入 vuex 组件
import $ from 'jquery';      // 引入 jquery 组件

export default {
    name: 'OrderManagement',
    data() {
        return {
            fansDialogVisible:false,  // 粉丝 dialog
            // memoDialogVisibale: false, // 备注 dialog
            // memo: {value:'',innerid:''},   //备注内容
            clickTableData: [], // 记录选中的表单数据
            tableData: [],  // 表单数据
            fansDetailsMsg: {}, // 粉丝详情
            searchData: {
                tagValue:"",        // 标签值
                time: {             // 开始/结束时间
                    date: ''
                },
                selectValue:'',     // 查询内容
            },
            // searchData:{        // 搜索数据集合
            //     tag:[{          // 标签 1 关注 2 购买  为空 全部来源
            //         value: "",
            //         label:"全部来源"
            //     },{
            //         value: 1,
            //         label:"关注"
            //     },{
            //         value: 2,
            //         label:"购买"
            //     }],
            //     tagValue:"",        // 标签值
            //     time: {             // 开始/结束时间
            //         date: ''
            //     },
            //     selectValue:'',     // 查询内容
            // },
            currentPage: 1,     // 初始化页数
            page: 1,            // 页数
            rowCount: 0,        // 数据条数
            apiData: {}         // api数据
        }
    },
      mounted() {
        // 接口参数配置
        this.apiData = {
            page: this.page,
            pagesize: 10
        };

        this.initTableData()
    },
    methods: {
        initTableData() {  // 初始化表单数据
            // 粉丝列表

         // 开启加载
        // this.setLoading(true);
        this.setLoading(true)

        findOrderFansList({
            data: this.apiData,
            success:data => {

                // 关闭加载
                // this.setLoading(false);
                this.setLoading(false)

                // 粉丝列表数据渲染
                this.tableData = data.data.content;
                // 页数设置
                this.rowCount = data.data.pageinfo.rowCount;

                // console.log(data);
            },
            error:data => {
                // 关闭加载
                // this.setLoading(false);
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
        },
        search() {
            // 搜索条件
            let tagValue = this.searchData.tagValue, // 来源条件
                param = this.searchData.time,     // 开始日期 and 结束日期
                begintime = '',
                endtime = '',
                name = "",
                mobileno = ""    // 搜索数据

                console.log(param)
                if (param.date !== null) {
                    begintime = param.date[0]
                    endtime = param.date[1]
                }
                // if (param.date[0]) {
                //     begintime = param.date[0]
                //     endtime = param.date[1]
                // }

            // 判断数据是否为手机号
            // if(!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.searchData.selectValue)) {
            //     name = this.searchData.selectValue;
            // } else {
            //     mobileno = this.searchData.selectValue;
            // }

            this.apiData = {
                // LoginToken: this.token,
                // ShopID: this.shopID,
                search: tagValue,
                // name: name,
                // mobileno: mobileno,
                // fansource: tagValue,
                begintime: begintime,
                endtime: endtime,
                page: this.page,
                pagesize: 10,
            };

            // 粉丝列表
            this.initTableData()
        },
        
        // 分页
        fPage() {

            // 开启加载
            // this.setLoading(true);
            this.setLoading(true)

            let clickPage = $(".el-pagination .active").html()
            this.apiData.page = clickPage

            // 粉丝列表
            this.initTableData()
        },
          // 点击获取粉丝详情
        clickFansDetails(innerid) {

            this.setLoading(true)

            // 粉丝详情接口
            getFansInfo({
                data:{
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    innerid: innerid,
                },
                success:data => {

                    this.fansDetailsMsg = data.data
                    this.fansDialogVisible = true;

                    this.setLoading(false)
                },
                error:data => {

                    this.setLoading(false)
                }
            })

            // fansDialogVisible

        },
        ...mapActions ([
            'setLoading'
        ])
        // // 选中表单数据
        // changeTableItem(val) {
        //     this.clickTableData = val
        // },
        //  点击备注弹窗
        // clickMemo(innerid) {

        //     // 启动弹窗
        //     this.memoDialogVisibale = true

        //     // 存储当前点击事件的 id
        //     this.memo.innerid = innerid
        // },

        // 提交备注
        // memoSubmit() {

        //     this.setLoading(true)

        //     // 备注信息不为空时
        //     if(this.memo.value !== "") {

        //         // 调用增加备注接口
        //         saveFansMemo({
        //             data:{
        //                 // LoginToken: this.token,
        //                 innerid: this.memo.innerid,
        //                 memo: this.memo.value
        //             },
        //             success:data=>{
        //                 this.setLoading(false)

        //                 if(data.code == "000") {

        //                     this.$message({
        //                         type:"success",
        //                         message:"备注添加成功"
        //                     });

        //                     // 动态修改本地 粉丝管理列表 tableData 的数据
        //                     this.updateTableJson(this.memo.innerid,this.memo.value)

        //                     // 初始化 备注
        //                     this.clearMemo()
        //                 }

        //             },
        //             error:data=>{

        //                 this.setLoading(false)
        //                 this.clearMemo()
        //                 console.log(data)
        //             }
        //         })
        //     } else {

        //         this.setLoading(false)
        //         this.$message.error('备注信息不能为空')
        //     }

        // },
        // 修改 json 数据
        // updateTableJson(innerid,value) {

        //     // innerid 相同 修改 粉丝管理列表 memo 的值
        //     for(let i = 0; i < this.tableData.length; i++) {

        //         if(this.tableData[i].innerid == innerid) {
        //             this.tableData[i].memo = value
        //         }

        //     }


        // },
        // 初始化备注信息
        // clearMemo(){
        //     this.memo.value = ''
        //     this.memo.id = ''
        //     this.memoDialogVisibale = false
        // },

      
        // 发送短信
        // postMessage(innerid) {

        //     if(this.clickTableData.length == 0 && innerid == undefined) {
        //         this.$message.warning('请勾选需要群发短信的粉丝')
        //         return
        //     }

        //     let data = ''
        //     // innerid 存在时为单发短信, 不存在时则为群发短信
        //     if(innerid) {
        //         // 取得对应数据
        //         this.tableData.forEach(json => {
        //             if(json.innerid === innerid) {
        //                 data = recombination([json])
        //                 return
        //             }
        //         })

        //     } else {
        //         data = recombination(this.clickTableData)
        //     }

        //     // 跳转页面
        //     this.$router.push('/marketingCenter/marketingCenter?data='+data)

        //     // location.href = '/marketingCenter/marketingCenter?data='+data


        //     // 重组数据
        //     function recombination(json) {
        //         let arr = []

        //         json.forEach(data => {
        //             let item = {
        //                 name: data.name,
        //                 innerid: data.innerid,
        //                 mobileno: data.mobileno
        //             }
        //             arr.splice(arr.length,0,item)
        //         })
        //         return JSON.stringify(arr)
        //     }
        // }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {Loading}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.OrderManagement {
    span {
            font-size: 14px;
        }

        .el-date-editor {
            margin-right: 20px;
            .el-range-separator {
                line-height: 25px;
                color: #C0C4CC;
            }
        }
        .el-input__icon {
            line-height: 32px;
            height: 32px;
        }
        .el-menu--horizontal>.el-menu-item.is-active {
            color: #409EFF;
        }
        .el-menu--horizontal>.el-menu-item {
            height: 30px;
            line-height: 20px;
        }
        .el-input {
            height: 40px;
        }
        img {
            float:left;
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
        .fansmgt-table {
            width:100%;
            text-align:center;
            margin-top: 30px;

            .fansmgt-name {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: start;
                -ms-flex-pack: start;
                justify-content: flex-start;

                p {
                    padding-left: 10px;
                }


            }

            .fansmgt-position {
                .el-button {
                    min-width: auto;
                }
                i {
                    margin: 0 10px;
                    color: #409EFF;
                }
            }
        }


        .fansmgt-seach {
            margin-top: 30px;

            .marginright {
                margin-right: 20px;
            }

            .el-button {
                height: 32px;
            }
        }

        .post-message {
            background: #fff;
        }

        .el-pagination {
            margin-top: 20px
        }

        .fans-details {
            width: 560px;

            .headerimg {
                margin-right: 10px;
                width: 50px;
                height: 50px;
                border-radius: 100%;
            }
            .other-content {
                margin-top: 20px;
                padding-bottom: 20px;
                border: solid 1px #DCDFE6;
                border-left: none;
                border-right: none;
            }
            .sex {
                margin-right: 6px;
                width: auto;
                height: 14px;
                transform: translateY(-2px);
                transform: -webkit-translateY(-2px);
                transform: -ms-translateY(-2px);
                transform: -moz-translateY(-2px);
                transform: -o-translateY(-2px);
            }

            .fans-item {
                margin-top: 20px;

                span:last-child {
                    color: #303133
                }
                span:first-child {
                    color: #606266
                }
            }


            .city {
                margin-top: 18px;
            }
        }
}
</style>
